/**
 * Created by inonstelman on 1/1/15.
 */

Directives.SimpleTextTypingDirective = function SimpleTextTypingDirective() {

    // @ngInject
    function SimpleTextTypingDirectiveControllerFunc($scope, $injector, $timeout) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'SimpleTextTypingDirectiveController';
        this.$timeout = $timeout;

        this.animateTypingText();

        $scope.$watch('simpleTextTypingVm.text', function watchTextChange(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.animateTypingText();
            }
        }.bind(this));

    }

    var SimpleTextTypingDirectiveController = Class(Controllers.BaseController, {
        constructor: SimpleTextTypingDirectiveControllerFunc,

        animateTypingText: function animateTypingText() {
            this.curText = '';
            this.speed = this.speedMsec || 20;
            if (this.text && this.text.length > 0) {
                this._animateHelper(0);
                if (this.onStart) {
                    this.onStart();
                }
            }
        },

        _animateHelper: function _helper(cursor) {
            if (cursor < this.text.length) {
                this.$timeout(function() {
                    this.curText = this.curText.concat(this.text.charAt(cursor));
                    this._animateHelper(cursor + 1);
                }.bind(this), this.speed);
            } else {
                if (this.onFinish) {
                    this.onFinish();
                }
            }
        }
    });

    return {
        scope: {
            text: '=text',
            onStart: '&?',
            onFinish: '&?',
            speedMsec: '=speedMsec'
        },
        templateUrl: 'angular/app/modules/common/ui_components/text_typing_animation/simple_text_typing_directive_template.html',
        controller: SimpleTextTypingDirectiveController,
        controllerAs: 'simpleTextTypingVm',
        bindToController: true
    };
};
